import { createRouter } from '@tanstack/react-router';

import { MainLoader } from './_components';
import { queryClient } from './_shared';
import { routeTree } from './routeTree.gen';

export const tsRouter = createRouter({
  scrollRestoration: true,
  routeTree,

  defaultPendingComponent: () => <MainLoader />,
  context: {
    queryClient,
  },
  defaultPreload: 'intent',
  defaultPreloadDelay: 300,
  // Since we're using React Query, we don't want loader calls to ever be stale
  // This will ensure that the loader is always called when the route is preloaded or visited
  defaultPreloadStaleTime: 0,
});
